import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { setCookie, deleteCookie } from '../../utils/cookies';

/* =======================
   Initial State
======================= */
const initialState = {
  user: JSON.parse(sessionStorage.getItem('admin-user')) || null,
  token: sessionStorage.getItem('admin-token') || null,
  loading: false,
  error: null,
};

/* =======================
   Login
======================= */
// export const login = createAsyncThunk(
//   'auth/login',
//   async (credentials, { rejectWithValue }) => {
//     try {
//       const response = await axiosInstance.post(
//         '/api/admin/auth/login',
//         credentials
//       );

//       const { accessToken, user } = response.data.data;

//       sessionStorage.setItem('admin-token', accessToken);
//       sessionStorage.setItem('admin-user', JSON.stringify(user));
//       setCookie('token', accessToken, 7);

//       return { token: accessToken, user };
//     } catch (error) {
//       return rejectWithValue(error.response?.data);
//     }
//   }
// );

export const login = createAsyncThunk(
  'auth/login',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/admin/auth/login',
        credentials
      );

      const { accessToken, user } = response.data.data;
      const { message, success } = response.data;

      // store auth data
      sessionStorage.setItem('admin-token', accessToken);
      sessionStorage.setItem('admin-user', JSON.stringify(user));
      setCookie('token', accessToken, 7);
      return {
        success,
        message,
        token: accessToken,
        user
      };
    } catch (error) {
      console.log(error);
      return rejectWithValue(
        error.response?.data?.message || 'Login failed'
      );
    }
  }
);


export const forgotPassword = createAsyncThunk(
  'auth/forgotPassword',
  async (email, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/admin/auth/forgot-password',
        { email }
      );
      console.log('Forgot Password Response:', response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to send reset link'
      );
    }
  }
);


export const resetPassword = createAsyncThunk(
  'auth/resetPassword',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/admin/auth/reset-password',
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to reset password'
      );
    }
  }
);


export const logout = createAsyncThunk(
  'auth/logout',
  async (_, { rejectWithValue }) => {
    try {
      await axiosInstance.post('/api/admin/auth/logout');

      sessionStorage.removeItem('admin-token');
      sessionStorage.removeItem('admin-user');
      deleteCookie('token');

      return null;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Logout failed'
      );
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    updateAuthPermissions(state, action) {
      if (state.user) {
        state.user.permissions = action.payload;
      }
    },
    updateAuthUser: (state, action) => {
      state.user = {
        ...state.user,
        ...action.payload
      };
    }

  },
  extraReducers: (builder) => {
    builder
      /* LOGIN */
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
        state.user = action.payload.user;
      })
      .addCase(login.rejected, (state, action) => {
        console.log('rejected', action);
        state.loading = false;
        state.error = action.payload;
      })

      /* LOGOUT */
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.token = null;
      });
  },
});

export const { clearError, updateAuthPermissions, updateAuthUser } = authSlice.actions;
export default authSlice.reducer;
